import React from "react";
import { FaPhoneAlt } from "react-icons/fa";

const FloatingCallButton = () => {
    return (
        <div className="fixed bottom-6 left-6 z-50">
            <a
                href="tel:0862257632"
                className="flex items-center rounded-xl space-x-3 px-4 py-2 bg-orange-700 text-white shadow-lg hover:bg-white hover:text-[#33367b] transition duration-300 transform hover:scale-105"
            >
                <FaPhoneAlt size={18} />
                <span className="font-semibold text-[13px] sm:text-[14px] font-OpenSans">086 225 7632</span>
            </a>
        </div>
    );
};

export default FloatingCallButton;
